import { registerComponent } from '@gig/magic-common';
import OfferCardComponent from './offer-card.vue.js';

var OfferCard = registerComponent(OfferCardComponent);

export { OfferCard };
